@if (webinar.isUpcoming) {
  <div class="event-registation-actions" [class.inline]="inline">
    @if (webinar.isRegistrationOpen || (currentUserRegistered && !joinButtonAvailable)) {
      @if (!webinarIsFull || currentUserRegistered) {
        @switch (webinar.invitationStatus) {
          @case (invitationStatuses.STATUS_NOT_INVITED) {
            @switch (webinar.attendees.currentUserStatus) {
              @case (userAttenderStatuses.USER_STATUS_CONFIRMED) {
                <ng-container *ngTemplateOutlet="joiningButton; context: { joined: true }"></ng-container>
              }
              @case (userAttenderStatuses.USER_STATUS_CANCELED) {
                <ng-container *ngTemplateOutlet="joiningButton; context: { joined: false }"></ng-container>
              }
              @default {
                <button
                  mat-flat-button
                  [disabled]="isLoading || !webinar.isCompleteMandatoryContents"
                  class="button button--primary"
                  [ngClass]="buttonCss"
                  data-cy="webinar-sign-up"
                  (click)="changeUserAttendance()">
                  {{ (webinar.baseType === eventType.WEBINAR ? 'WEBINARS.sign_up_for_the_webinar' : 'EVENTS.sign_up_for_the_event') | translate }}
                </button>
              }
            }
          }
          @case (invitationStatuses.STATUS_WAITING_FOR_APPROVAL) {
            <button
              mat-flat-button
              class="button button--primary"
              [ngClass]="buttonCss"
              [disabled]="isLoading || !webinar.isCompleteMandatoryContents"
              (click)="changeUserAttendance()"
              data-cy="webinar-accept-invitation">
              {{ 'WEBINARS.accept_invitation' | translate }}
            </button>
            <button
              mat-flat-button
              class="button button--outline"
              [ngClass]="buttonCss"
              [disabled]="isLoading || !webinar.isCompleteMandatoryContents"
              (click)="changeUserAttendance(false)"
              data-cy="webinar-reject-invitation">
              {{ 'WEBINARS.reject_invitation' | translate }}
            </button>
          }
          @default {
            <ng-container
              *ngTemplateOutlet="joiningButton; context: { joined: webinar.invitationStatus === invitationStatuses.STATUS_ACCEPTED }">
            </ng-container>
          }
        }
      } @else {
        @if (webinar.limitParticipants?.waitingListEnabled) {
          @switch (webinar.attendees.currentUserStatus) {
            @case (userAttenderStatuses.USER_STATUS_WAITING) {
              <ng-container *ngTemplateOutlet="waitingCancelButton"></ng-container>
            }
            @default {
              <button
                mat-flat-button
                [disabled]="!webinar.isCompleteMandatoryContents"
                class="button button--outline"
                [ngClass]="buttonCss"
                (click)="changeUserAttendance(true, true)">
                {{'WEBINARS.join_waiting_list' | translate}}
              </button>
            }
          }
        }
      }
    }
    @if (joinButtonAvailable) {
      @if ((webinar.isConnectedWithProvider || webinar.provider === webinarProviders.MS_TEAMS) ? webinar.type === types.MEETING : webinar.customJoinUrl) {
        <button
          mat-flat-button
          class="button button--primary"
          [ngClass]="buttonCss"
          [disabled]="!webinar.isCompleteMandatoryContents"
          (click)="joinWebinar()"
          data-cy="webinar-banner-join-button">
          {{'WEBINAR.join_webinar' | translate}}
        </button>
      }
      @if (webinar.isConnectedWithProvider && webinar.provider === webinarProviders.ZOOM) {
        <button
          mat-flat-button
          class="button button--primary-outline button--primary-text"
          [ngClass]="buttonCss"
          [disabled]="!webinar.isCompleteMandatoryContents"
          (click)="joinViaApp()">
          {{'WEBINAR.join_via_app' | translate}}
        </button>
      }
    }
  </div>
}

<ng-template #joiningButton let-joined="joined">
  <button
    mat-flat-button
    class="button button--gray"
    [ngClass]="buttonCss"
    [disabled]="isLoading || !webinar.isCompleteMandatoryContents"
    [matMenuTriggerFor]="joinMenu">

    <lib-icon [icon]="joined ? 'check' : 'x'" [size]="inline ? 20 : 24"></lib-icon>

    {{ (joined ? 'WEBINARS.you_are_joining' : 'WEBINARS.you_are_not_joining') | translate }}

    <lib-icon class="button-caret" icon="caret-down" [size]="inline ? 20 : 24"></lib-icon>

  </button>

  <mat-menu #joinMenu="matMenu" xPosition="before" class="base-context-menu">
    <button class="base-menu-button" mat-menu-item (click)="changeUserAttendance(!joined)">
      <lib-icon [icon]="!joined ? 'check' : 'x'"></lib-icon>

      {{ (!joined ? 'WEBINARS.you_are_joining' : 'WEBINARS.you_are_not_joining') | translate }}
    </button>
  </mat-menu>
</ng-template>

<ng-template #waitingCancelButton>
  <button
    mat-flat-button
    class="button button--gray"
    [ngClass]="buttonCss"
    [disabled]="isLoading || !webinar.isCompleteMandatoryContents"
    [matMenuTriggerFor]="waitingListMenu">

    <lib-icon icon="check" [size]="inline ? 20 : 24"></lib-icon>

    {{ 'WEBINARS.you_are_on_the_waiting_list' | translate }}

    <lib-icon class="button-caret" icon="caret-down" [size]="inline ? 20 : 24"></lib-icon>

  </button>

  <mat-menu #waitingListMenu="matMenu" xPosition="before" class="base-context-menu">
    <button class="base-menu-button" mat-menu-item (click)="changeUserAttendance(false, true)">
      <lib-icon icon="x"></lib-icon>

      {{  'WEBINAR.exit_waiting_list' | translate }}
    </button>
  </mat-menu>
</ng-template>
